import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { Incontro, IncontroCreate } from "@/types/api";

/** Invalida sia la lista admin sia il KPI della Panoramica. */
function useInvalida() {
  const qc = useQueryClient();
  return () => {
    qc.invalidateQueries({ queryKey: ["admin-incontri"] });
    qc.invalidateQueries({ queryKey: ["incontro-prossimo"] });
  };
}

export function useAdminIncontri() {
  return useQuery({
    queryKey: ["admin-incontri"],
    queryFn: () => apiFetch<Incontro[]>("/api/v1/admin/incontri"),
    staleTime: 15_000,
  });
}

export function useCreaIncontro() {
  const invalida = useInvalida();
  return useMutation({
    mutationFn: (body: IncontroCreate) =>
      apiFetch<Incontro>("/api/v1/admin/incontri", {
        method: "POST",
        body: JSON.stringify(body),
      }),
    onSuccess: invalida,
  });
}

export function useAggiornaIncontro() {
  const invalida = useInvalida();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: Partial<IncontroCreate> }) =>
      apiFetch<Incontro>(`/api/v1/admin/incontri/${id}`, {
        method: "PATCH",
        body: JSON.stringify(body),
      }),
    onSuccess: invalida,
  });
}

export function useEliminaIncontro() {
  const invalida = useInvalida();
  return useMutation({
    mutationFn: (id: string) =>
      apiFetch<void>(`/api/v1/admin/incontri/${id}`, { method: "DELETE" }),
    onSuccess: invalida,
  });
}
